import { render, staticRenderFns } from "./profile_edit.vue?vue&type=template&id=70295968&scoped=true"
import script from "./profile_edit.vue?vue&type=script&lang=js"
export * from "./profile_edit.vue?vue&type=script&lang=js"
import style0 from "./profile_edit.vue?vue&type=style&index=0&id=70295968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70295968",
  null
  
)

export default component.exports